import {useNavigate} from "react-router-dom";
import {Button, Flex, Modal, Select, Text, TextInput, Tooltip} from "@mantine/core";
import React, {Fragment, useState} from "react";
import {IconChevronDown, IconCircleNumber1, IconSearch} from "@tabler/icons-react";
import classes from "../css/Results.module.css";
import {useDisclosure} from "@mantine/hooks";
import {useDispatch, useSelector} from "react-redux";
import {setCustomer} from "../redux/actions";
import {useTranslation} from "react-i18next";

export default function BreadcrumbsBar({ goBack, id, isMultiCustomer, customers }) {
    const [search, setSearch] = useState("")
    const { t} = useTranslation();

    const submit = (e) => {

        if (search === "") {
            return
        }

        const searchWithNoWhiteSpace = search.replace(/\s/g, ''); //replace whitespace

        fetch(`/api/v1/Activation/${searchWithNoWhiteSpace}`, {
            method: "GET",
            credentials: 'include',
        }).then(response => response.json())
            .then(result => {
                if (result) {
                    navigate(`/${searchWithNoWhiteSpace}`)
                    if(id){
                        window.location.reload()
                    }
                } else {
                    openError()
                }
            }).catch((error) => {
            console.log(error)
            //alert("Network Error, please try again!")
        })
    }
    const navigate = useNavigate()
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            submit()
        }
    };
    const [openedError, { open: openError, close: closeError }] = useDisclosure(false);

    const currentCustomer = useSelector(state => state.customer.currentCustomer);
    const dispatch = useDispatch();

    const handleSetCustomer = (newCustomer) => {
        //localStorage.setItem("currentCustomer", newCustomer); //uncomment if want local storage to be consistent, otherwise will default to first customer
        dispatch(setCustomer(newCustomer))
    }

    return(<>
        <Modal opened={openedError} onClose={closeError} size="md" title={t("Activation Not Found")}>
            {t("sn-not-found",{n: search})}
        </Modal>
        <Flex
            id="bar"
            mih={40}
            justify="space-between"
            align="flex-start"
            direction="row"
            wrap="nowrap"
        >

                <Flex
                    id="search"
                    mih={40}
                    justify="flex-start"
                    align="flex-start"
                    direction="row"
                    wrap="nowrap"
                >
                    <TextInput
                        size="md"
                        radius="sm"
                        type="search"
                        value={search}
                        placeholder={t("Endpoint SN")}
                        styles={{input: {textOverflow: 'ellipsis'}}}
                        onChange={(e) => setSearch(e.target.value)}
                        name="text"
                        id="text"
                        onKeyUp={handleKeyPress}
                        leftSection={<IconSearch/>}
                    />
                    <Button
                        className={classes.searchButton} onClick={submit} size="md">{t("Search")}</Button>
                </Flex>

            {goBack ? (
                <Button size="md" style={{height: "30px", marginBottom: "10px", marginRight: "10px"}} type={"submit"}
                        onClick={goBack}>{t("Go Back")}</Button>) : (isMultiCustomer ? (<Flex><Text mt="10">{t("Customer Name")}: </Text>
                <Tooltip transitionProps={{ transition: 'slide-down', duration: 300 }} openDelay={1000} position="top" label={currentCustomer} withArrow={true}><div><Select
                    ml="10"
                    data={customers}
                    value={currentCustomer}
                    onChange={handleSetCustomer}
                    allowDeselect={false}
                    size="md"
                    rightSection={<IconChevronDown/>}
                    withScrollArea={false}
                    styles={{ dropdown: { maxHeight: 200, overflowY: 'auto'}, input: {textOverflow: 'ellipsis'} }}
                    //makes it in-line with search bar
                /></div></Tooltip></Flex>) : (<Flex><Text mt="10">{t("Customer Name")}: </Text><Tooltip transitionProps={{ transition: 'slide-down', duration: 300 }}  position="bottom" label={currentCustomer} withArrow={true}><div><Select
                    ml="10"
                    className={classes.noClick}
                    size="md"
                    data={customers}
                    value={currentCustomer}
                    styles={{input: {textOverflow: 'ellipsis'}}}
                    rightSection={<IconCircleNumber1 color="white"/>}
                />
            </div>
            </Tooltip>
            </Flex>))}

        </Flex>
    </>)
}